export const errorTypes = {
  effectsEmpty: 'effectsEmpty',
}
